import { render, staticRenderFns } from "./Lower.vue?vue&type=template&id=c866bc06"
import script from "./Lower.vue?vue&type=script&lang=js"
export * from "./Lower.vue?vue&type=script&lang=js"
import style0 from "./Lower.vue?vue&type=style&index=0&id=c866bc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports